import React from 'react';

// Freccia di scarico pezza (sostituisce l'immagine esterna di icons8).
export const DischargeIcon: React.FC<{ title: string }> = ({ title }) => (
    <svg width="12" height="12" viewBox="0 0 12 12" role="img" aria-label={title} className="block">
        <title>{title}</title>
        <path d="M1 5h6.5L5.8 3.3 6.5 2.6 10 6l-3.5 3.4-.7-.7L7.5 7H1z" fill="#000" />
    </svg>
);
